import React, { ReactElement, useEffect } from 'react';
import { LoaderButton } from 'idsk-react-components';
import LegislationProcessInfo from '../../../../model/currentuser/LegislationProcessInfo';
import iconDownload from '../../../../../assets/images/icon-download-blue.svg';
import './vzneseneInMpkLink.scss';
import { useClient, useClientStatusContext } from '../../../../context/ClientStatusContext';
import downloadFile from '../../../../function/downloadFile';
import {
  downloadSprievodnyDokument,
} from '../../../../client/external/sprievodnyDokumentDownloadClient';
import DownloadFromStadiumEnum from '../../../../model/downloadFromStadiumEnum';
import useSprievodnyDokumentContext
  from '../../../../context/SprievodnyDokumentContext/hooks/useSprievodnyDokumentContext';
import vznesenePripomienkyNotFoundStatus from '../../../../constants/FileDownloadErrorConstant';

interface Props {
  legislationProcess: LegislationProcessInfo;
}

const VzneseneInMpkLink = ({
  legislationProcess,
}: Props): ReactElement => {
  const { vznesenePripomienkyExistsStatus } = useSprievodnyDokumentContext();

  const {
    wrapClient: downloadSprievodnyDokumentClient,
    status: downloadSprievodnyDokumentStatus,
  } = useClient(downloadSprievodnyDokument);
  const { handleStatus } = useClientStatusContext();

  useEffect(() => {
    if (downloadSprievodnyDokumentStatus.responseCode === 404) {
      handleStatus(vznesenePripomienkyNotFoundStatus);
    }
  }, [downloadSprievodnyDokumentStatus, handleStatus]);

  const downloadDokument = async (): Promise<void> => {
    const { data } = await downloadSprievodnyDokumentClient(
      legislationProcess.legMaterialUuid,
      'VznesenePripomienkyVRamciMedzirezortnehoPripomienkovehoKonania',
      DownloadFromStadiumEnum.ANY_PREVIOUS,
    );

    if (data.blob) {
      downloadFile(data.fileName, data.blob);
    }
  };

  // Compared against the raw wire value, not SprievodnyDokumentStatusEnum's generated member
  // name - openapi-generator's prefix-stripping for this enum's member names is not stable
  // across generation runs.
  return (vznesenePripomienkyExistsStatus?.status === 'DOCUMENT_EXISTS' ? (
    <LoaderButton
      customIconBefore={iconDownload}
      loading={downloadSprievodnyDokumentStatus.loading}
      size="small"
      buttonStyle="link"
      className="vznesene-in-mpk-link"
      onClick={downloadDokument}
    >
      Vznesené pripomienky v rámci PK
    </LoaderButton>
  ) : null);
};

export default VzneseneInMpkLink;
